module.exports = __WEBPACK_EXTERNAL_MODULE_127__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 127
// module chunks = 3